import { render, staticRenderFns } from "./FeaturedCollections.vue?vue&type=template&id=438d49e1&scoped=true"
import script from "./FeaturedCollections.vue?vue&type=script&lang=js"
export * from "./FeaturedCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d49e1",
  null
  
)

export default component.exports